import { TAG_FEED_PAGE, TAG_FEED_PATH_PREFIX } from '@townsquare/config/routes';
import { createSiteRoute } from '@townsquare/router/create-route';

export const tagFeedViewRoute = createSiteRoute({
  exact: true,
  name: TAG_FEED_PAGE,
  path: `${TAG_FEED_PATH_PREFIX}/:id`,
  layout: 'home',
  subproduct: 'townsquare-tags',
});
